import PropTypes from 'prop-types'

import Text from 'components/common/Text'
import Icon from 'components/Icon'
import theme from 'theme'

const CloseIcon = (props) => <Icon icon="close" {...props} />
const CheckmarkIcon = (props) => <Icon icon="solidCheck" {...props} />

const ResponseLine = ({ fieldName, type, formattedActual, ...rest }) => {
  let Icon = null
  let color = theme.colors.steel[1]

  switch (type) {
    case 'error':
      Icon = CloseIcon
      color = theme.colors.red[0]
      break

    case 'success':
      Icon = CheckmarkIcon
      color = theme.colors.green[1]
      break
  }

  return (
    <div
      css={{
        paddingTop: theme.space[1],
        paddingBottom: theme.space[1],
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center'
      }}
      {...rest}
    >
      {Icon ? (
        <Icon
          css={{
            color,
            marginRight: theme.space[2]
          }}
        />
      ) : (
        <div
          css={{
            width: theme.space[3],
            height: theme.space[3],
            marginRight: theme.space[2]
          }}
        />
      )}
      <Text
        as="div"
        css={{
          color,
          marginRight: theme.space[2]
        }}
      >
        {fieldName}: {formattedActual}
      </Text>
    </div>
  )
}

ResponseLine.propTypes = {
  type: PropTypes.oneOf(['success', 'neutral', 'error']),
  fieldName: PropTypes.string,
  formattedActual: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool
  ])
}

export default ResponseLine
